module.exports = __webpack_public_path__ + "static/media/term.32fbbfde.png";